import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import Axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
import server from '../../../variables'
import NavbarSA from '../../../components/navbar-sa'

const ViewBillUser = () => {
  const notyf = new Notyf()
  const [bill, setBill] = useState({})
  const [consumer, setConsumer] = useState({})
  const navigate = useNavigate()

  const consumerID = useParams().consumer
  const billID = useParams().bill

  const getBill = async () => {
    try {
      const { data } = await Axios.get(
        server + 'user/get-bill/' + billID,
        {
          headers: { authorization: localStorage.getItem('token') },
        }
      )

      if (data.status === 410) {
        navigate('/')
      } else if (data.status === 200) {
        setBill(data.bill)
        setConsumer(data.user)
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      notyf.error('Internal Server Error!')
    }
  }

  useEffect(() => {
    document.title = 'Rean Billing System'
    getBill()
  }, [])

  return (
    <>
      <NavbarSA />

      <div className="container mt-4">
        <div className="page-title mb-3">
          Bill ({bill.billID})
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10 col-12">
            <div className="card shadow-sm">
              <div className="card-header bg-light fw-bold">
                Bill Details
              </div>

              <div className="card-body">
                <form>
                  <div className="row g-3">

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Consumer ID"
                        value={bill.consumerID || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Consumer Name"
                        value={
                          consumer?.consumerType === 'Commercial Consumer'
                            ? consumer?.bussinessName
                            : consumer?.consumerName || ''
                        }
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Consumer Type"
                        value={consumer?.consumerType || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Meter Number"
                        value={consumer?.meterNumber || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Mobile Number"
                        value={consumer?.mobileNumber || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Due Date"
                        value={bill.dueDate?.split('T')[0] || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Reading Date"
                        value={bill.readingDate?.split('T')[0] || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Total Consumption"
                        value={bill.totalConsumption || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Previous Meter Reading"
                        value={bill.lastMeterReading || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Current Meter Reading"
                        value={bill.currentMeterReading || ''}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Penalty"
                        value={bill.penalty || 0}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Fixed Charges"
                        value={bill.fixedCharges || 0}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <TextField
                        label="Other Charges"
                        value={bill.otherCharges || 0}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="col-12">
                      <TextField
                        label="Total Amount Payable"
                        value={bill.fixedCharges || 0}
                        fullWidth
                        size="small"
                        disabled
                      />
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewBillUser
